import { CestaProductRevisionMoto } from './constants'
import { Product, Service } from '../../common/context/reducers/cestaReducer'
import { CategoriaCesta, TipoProductoCesta } from './type/Cesta'

export const isProductRevisionMoto = (product: Product) => {
  return (
    !!product &&
    product.tipo_producto.toString().toLowerCase() === CestaProductRevisionMoto
  )
}

export const isCestaType = (
  products: Product[],
  category?: CategoriaCesta,
  include?: TipoProductoCesta[],
  exclude?: TipoProductoCesta[]
) =>
  products.length > 0 &&
  products.every(
    (p) => {
      return (!category || p.categoria === null || p.categoria === category) &&
      (!include || include.includes(p.tipo_producto)) &&
      (!exclude || !exclude.includes(p.tipo_producto))
    }
  )

export const isCestaMoto = (products: Product[]) =>
  isCestaType(products, 'moto')
export const isCestaCoche = (products: Product[]) =>
  isCestaType(products, 'coche', undefined, ['bateria', 'aceite'])
export const isCestaBateria = (products: Product[]) =>
  isCestaType(products, undefined, ['bateria'])
export const isCestaAceite = (products: Product[]) =>
  isCestaType(products, undefined, ['aceite'])
export const isCestaRevisionMoto = (products: Product[]) =>
  isCestaType(products, 'moto', ['revision_moto'])
// consideramos cesta catalogo productos que podemos añadir más de 1
export const isCestaCatalogo = (products: Product[]) =>
  isCestaType(products, undefined, ['neumatico', 'bateria', 'aceite'])
export const isCestaAC2 = (products: Product[]) =>
  products.some((p) => p.tipo_producto === 'ac2')
export const isCestaAC1 = (products: Product[]) =>
  products.some((p) => p.tipo_producto === 'ac')
export const isCestaWithAccesoriosSeguridad = (products: Product[]) => 
  products.some((p) => ['acc-seguridad'].includes(p.tipo_producto))
export const isCestaWithAccesoriosTransporte = (products: Product[]) => 
  products.some((p) => ['acc-portabici', 'acc-portaesqui', 'acc-cofre', 'acc-otros'].includes(p.tipo_producto))
// es una cesta con accesorios
export const isCestaAccesoriosTransporte = (products: Product[]) => products.length > 0 &&
  products.every((p) => ['acc-portabici', 'acc-portaesqui', 'acc-cofre', 'acc-otros'].includes(p.tipo_producto))
export const isCestaEnvioDomicilio = (services: Service[]) => services.length > 0 &&
services.some((s) => ['ENVIO_PEQ', 'ENVIO_MED', 'ENVIO_GR'].includes(s.id_navision) && s.selected)

export const isAmbiguosVehicle = (cestaState: any) => {
  const ano_fabricacion = (cestaState.newVehicleData?.ano_fabric && cestaState.newVehicleData.ano_fabric > 0) ? cestaState.newVehicleData.ano_fabric
                        : (cestaState.newVehicleData?.ano_matric && cestaState.newVehicleData.ano_matric > 0) ? cestaState.newVehicleData.ano_matric
                        : 0
  return ano_fabricacion >= 2013 && ano_fabricacion <= 2017;
}
  
export const isCestaWithAccesoriosTransporteMoto = (products: Product[]) => 
  products.some((p) => ['accm-maleta', 'accm-respaldo', 'accm-bolsa'].includes(p.tipo_producto))
export const isCestaAccesoriosTransporteMoto = (products: Product[]) => products.length > 0 &&
  products.every((p) => ['accm-maleta', 'accm-respaldo', 'accm-bolsa'].includes(p.tipo_producto))




